class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.cookieName = `Minimog:promo-popup-${this.id}`;
    this.cookie = getCookie(this.cookieName);

    this.modal = this.querySelector(".m-modal");
    this.modalContent = this.modal.querySelector(".m-modal--content");

    this.closeButtons = this.querySelectorAll("[data-promo-popup-close]");
    
    if (this.cookie === "" && this.dataset.enable === "true") {
      if (Shopify && Shopify.designMode) return;
      setTimeout(() => {
        this.openPopup();
      }, parseInt(this.dataset.delay || 0) * 1000);
    }
  }

  connectedCallback() {
    if (this.closeButtons.length) {
      this.closeButtons.forEach(btn => {
        btn.addEventListener("click", (e) => {
          if (btn.tagName === "BUTTON") e.preventDefault();
          if (this.dataset.enable === "true") {
            setCookie(this.cookieName, "closed", parseInt(this.dataset.cookieTime || 30));
          }
          this.closePopup();
        });
      });
    }

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", this.__shopifySectionSelect.bind(this));
      document.addEventListener("shopify:section:deselect", this.__shopifySectionDeselect.bind(this));
      document.addEventListener("shopify:section:load", this.__shopifySectionLoad.bind(this));
    }
  }

  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener("shopify:section:select", this.__shopifySectionSelect.bind(this));
      document.removeEventListener("shopify:section:deselect", this.__shopifySectionDeselect.bind(this));
      document.removeEventListener("shopify:section:load", this.__shopifySectionLoad.bind(this));
    }
  }

  __shopifySectionLoad(event) {
    if (event.detail.sectionId === this.dataset.sectionId && this.dataset.designMode === "true") {
      this.openPopup();
    }
  }

  __shopifySectionSelect(event) {
    if (event.detail.sectionId === this.dataset.sectionId && this.dataset.designMode === "true") {
      this.openPopup();
    }
  }

  __shopifySectionDeselect(event) {
    if (event.detail.sectionId === this.dataset.sectionId) {
      this.closePopup();
    }
  }

  openPopup() {
    this.modal.style.setProperty("--m-opacity", "1");
    this.modal.classList.add("m-open-modal");
    document.documentElement.classList.add("prevent-scroll");
  }

  closePopup() {
    this.modal.classList.remove("m-open-modal");
    this.modal.style.setProperty("--m-opacity", "0");
    document.documentElement.classList.remove("prevent-scroll");
  }
}

customElements.define("m-promo-popup", PromoPopup);
